mutation TagCategoryDelete($input: TagCategoryDeleteInput!) {
  tagCategoryDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
